<template>
  <div class="bp-table-header">
    <div class="total-slot">
      <span class="text-neutral-400 functional-1">Total: {{ total }}</span>
      <bp-button
        size="md"
        color="neutral"
        variant="glyph"
        icon="fa-light fa-refresh"
        @click="$emit('refresh')"
      />
      <div class="ml-auto ml-lg-0">
        <slot name="grid" />
      </div>
    </div>
    <div class="input-slot">
      <div class="flex-fill">
        <slot name="input" />
      </div>
      <div class="d-none d-lg-block" v-if="$slots['date-picker']">
        <slot name="date-picker" />
      </div>
      <bp-button
        v-if="showFilter"
        size="md"
        color="neutral"
        variant="filled-1"
        icon="fa-regular fa-filter"
        @click="$emit('open-filter')"
      />
    </div>
    <div class="buttons-slot">
      <slot name="buttons"></slot>
    </div>
    <div class="picker-mobile" v-if="$slots['date-picker']">
      <slot name="date-picker" />
    </div>
    <slot name="filter"></slot>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showFilter() {
      return !!this.$slots?.filter;
    }
  }
};
</script>

<style lang="scss" scoped>
.bp-table-header {
  gap: 4px;
  display: grid;
  align-items: center;
  grid-template-columns: minmax(40%, 60%) 1fr auto;

  .total-slot {
    order: 1;
    gap: 4px;
    display: flex;
    align-items: center;
  }
  .input-slot {
    order: 2;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .buttons-slot {
    order: 3;
    gap: 4px;
    display: flex;
  }

  .picker-mobile {
    display: none;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    align-items: unset;
    gap: 16px;

    .input-slot {
      order: 1;
    }
    .picker-mobile {
      display: flex;
      flex-direction: column;
      order: 2;
    }
    .buttons-slot {
      order: 3;
      gap: 8px;
      & > * {
        flex: 1 1 auto;
      }
    }
    .total-slot {
      order: 4;
    }
  }
}
</style>
